import React, { useState, useEffect } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import Header from './Header';
import Table from './Table';
import { BaseTableRQ } from 'components/common/models/BaseClass';
import {
  importSupplier,
  searchSuppliers
} from 'services/supplier/supplierDashboardService';
import SyncData from './SyncData';
import { usePaginationBe } from 'hooks/useBeHandle';
import PageHeader from 'components/common/PageHeader';
import { toast } from 'react-toastify';

const RunningSuppliers = () => {
  const defaultRQ = { ...new BaseTableRQ(1, 10) };
  const [actionPlans, setActionPlans] = useState([]);
  const [total, setTotal] = useState(0);
  const [paging, setPaging] = useState({ ...defaultRQ });
  const [isSyncShow, setIsSyncShow] = useState(false);
  const [colSort, setColSort] = useState(undefined);
  const [keyword, setKeyword] = useState('');

  useEffect(() => {
    loadData(defaultRQ);
  }, []);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      loadData({
        ...paging,
        pageNum: 1
      });
    }, 700);

    return () => clearTimeout(delayDebounce);
  }, [keyword]);

  const toggelFilter = () => {
    setIsSyncShow(!isSyncShow);
  };

  const onImportSuppliers = async param => {
    const payload = param.map(x => ({
      supplierCode: x.value?.trim(),
      source: x.source
    }));

    const res = await importSupplier(payload);

    if (res.success) {
      toast.success(`Import successfully!!`);

      loadData({
        ...paging,
        pageNumber: 1
      });

      return true;
    } else {
      toast.error(res.message);
      return false;
    }
  };

  const loadData = pagingRq => {
    const rq = {
      ...pagingRq,
      keyword: keyword
    };
    searchSuppliers(rq)
      .then(res => {
        if (res) {
          setActionPlans(res.items);
          setTotal(res.total);
          let cl = {
            ...pagingRq,
            sortBy: pagingRq.sortBy,
            desc: pagingRq.desc,
            isBeSortedDesc: pagingRq.desc,
            isBeSorted: pagingRq.sortBy != undefined && pagingRq.sortBy != ''
          };
          setColSort(cl);
          setPaging(cl);
        }
      })
      .catch(err => {
        console.log(err);
      });
    setPaging(pagingRq);
  };

  const { gotoPage, nextPage, previousPage, handleSort } = usePaginationBe(
    paging,
    total,
    loadData
  );

  return (
    <>
      <PageHeader
        title="Supplier Dashboard"
        description={`Manage and view all available Supplier from this page.`}
        className="mb-3"
      ></PageHeader>
      <Row className="g-3 mb-3">
        <Col lg={12}>
          <Card>
            <Row style={{ padding: '10px' }}>
              <Header
                toggelFilter={() => toggelFilter()}
                style={{ padding: '10px' }}
                keyword={keyword}
                setKeyword={setKeyword}
                onSearch={() =>
                  loadData({
                    ...paging,
                    pageNumber: 1
                  })
                }
              />
              {isSyncShow && (
                <Col
                  lg={12}
                  style={{ paddingBottom: '10px', paddingTop: '10px' }}
                >
                  <SyncData onImportSuppliers={onImportSuppliers} />
                </Col>
              )}
              <Col lg={12}>
                <Table
                  data={actionPlans}
                  paging={paging}
                  total={total}
                  nextPage={nextPage}
                  previousPage={previousPage}
                  gotoPage={gotoPage}
                  colSort={colSort}
                  handleSort={handleSort}
                />
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default RunningSuppliers;
